import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { navLinks, siteInfo } from "@/mocks/site";

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const isActive = (to: string) =>
    to === "/" ? location.pathname === "/" : location.pathname.startsWith(to);

  return (
    <header className="sticky top-0 z-50 w-full">
      <div className="hidden w-full items-center justify-between border-b border-background-200 bg-background-100 px-6 py-1.5 text-xs text-foreground-600 md:flex lg:px-10">
        <p className="tracking-wide">
          {siteInfo.tagline} · 不做判断，只标来源与可信度
        </p>
        <p className="whitespace-nowrap">档案最近更新：{siteInfo.updatedAt}</p>
      </div>

      <div
        className={`w-full border-b transition-colors duration-300 ${
          scrolled
            ? "border-background-200 bg-background-50/95 backdrop-blur"
            : "border-background-200/70 bg-background-50"
        }`}
      >
        <div className="flex w-full items-center justify-between gap-4 px-4 py-3 md:px-6 md:py-4 lg:px-10">
          <Link to="/" className="group flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-lg font-bold text-background-50">
              五
            </span>
            <span className="flex flex-col leading-tight">
              <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
                511 求证档案
              </span>
              <span className="hidden text-[11px] tracking-[0.2em] text-foreground-500 sm:block">
                VERIFY · TIMELINE · ARCHIVE
              </span>
            </span>
          </Link>

          <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`whitespace-nowrap rounded-md px-3 py-2 text-sm transition-colors ${
                  isActive(link.to)
                    ? "bg-primary-100 font-medium text-primary-700"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <Link
              to="/about#tips"
              className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
            >
              提交线索
            </Link>
            <button
              type="button"
              aria-label={open ? "关闭菜单" : "打开菜单"}
              aria-expanded={open}
              onClick={() => setOpen((v) => !v)}
              className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 lg:hidden"
            >
              <i className={open ? "ri-close-line text-xl" : "ri-menu-3-line text-xl"}></i>
            </button>
          </div>
        </div>

        {open && (
          <nav
            className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden"
            aria-label="移动端导航"
          >
            <ul className="flex flex-col gap-1">
              {navLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className={`block rounded-md px-3 py-2.5 text-sm ${
                      isActive(link.to)
                        ? "bg-primary-100 font-medium text-primary-700"
                        : "text-foreground-700"
                    }`}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
              <li className="pt-1">
                <Link
                  to="/about#tips"
                  className="block whitespace-nowrap rounded-md bg-primary-500 px-3 py-2.5 text-center text-sm font-medium text-background-50"
                >
                  提交线索
                </Link>
              </li>
            </ul>
          </nav>
        )}
      </div>
    </header>
  );
}